import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-subtitle1 text-bold" }, "Logga ut", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { style: {"width":"400px"} }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, { class: "row items-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, {
            size: "sm",
            name: "mdi-logout-variant",
            class: "q-mr-sm"
          }),
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_q_separator),
      _createVNode(_component_q_card_section, { class: "row text-grey-8" }, {
        default: _withCtx(() => [
          _createTextVNode(" Är du säker på att du vill logga ut? ")
        ]),
        _: 1
      }),
      _createVNode(_component_q_separator),
      _createVNode(_component_q_card_actions, { align: "right" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_btn, {
            flat: "",
            label: "Avbryt",
            onClick: _ctx.close,
            disabled: _ctx.signOutLoading
          }, null, 8, ["onClick", "disabled"]),
          _createVNode(_component_q_btn, {
            flat: "",
            label: "Logga ut",
            color: "primary",
            loading: _ctx.signOutLoading,
            onClick: _ctx.onSignOut
          }, null, 8, ["loading", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}